import { api } from "./client.js";

export function listBrands({ signal } = {}) {
  return api("/api/brands", { signal });
}

export function brandHistory(brandId, { signal } = {}) {
  return api(`/api/brands/${brandId}/history`, { signal });
}

export function draftBrandOutreach(brandId, { domain, kind, regen = false }) {
  return api(`/api/brands/${brandId}/outreach`, {
    method: "POST",
    json: { domain, kind, regen },
  });
}

export function runBrand(brandId) {
  return api(`/api/brands/${brandId}/run`, { method: "POST" });
}

export function removeBrand(brandId) {
  return api(`/api/brands/${brandId}`, { method: "DELETE" });
}

export function brandProfile(brandId, { signal } = {}) {
  return api(`/api/brand/profile?brand_id=${encodeURIComponent(brandId)}`, { signal });
}

export function saveBrandProfile(brandId, profile, { signal } = {}) {
  return api("/api/brand/profile", {
    method: "POST",
    signal,
    json: { brand_id: brandId, profile, mode: "replace" },
  });
}

export function setBrandEntity(brandId, entity, { signal } = {}) {
  return api(`/api/brands/${brandId}/entity`, { method: "POST", signal, json: { entity } });
}

export function setBrandAliases(brandId, aliases, { signal } = {}) {
  return api(`/api/brands/${brandId}/aliases`, { method: "POST", signal, json: { aliases } });
}

export function onboardScan(payload, { signal } = {}) { return api("/api/onboard-scan", { method: "POST", signal, json: payload }); }
export async function diagnosisStatus(jobId, { signal } = {}) {
  const job = await api(`/api/jobs/${encodeURIComponent(jobId)}`, { signal });
  const result = job.result || {};
  return {
    ...result,
    status: job.state === "failed" ? "error" : job.state,
    step: job.progress ?? 0,
    msg: job.reason || job.stage || "Starting shortly",
  };
}
export function aliasSuggest(brand, url = "", { signal } = {}) { return api(`/api/alias-suggest?brand=${encodeURIComponent(brand)}&url=${encodeURIComponent(url)}`, { signal }); }
